import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Play from "./pages/Play";
import MyProfile from "./pages/MyProfile";
import Users from "./pages/Users";
import Library from "./pages/Library";
import Playlists from "./pages/Playlists";
import Locations from "./pages/Locations";
import Screens from "./pages/Screens";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import AppLayout from "./layout/AppLayout";
import FrontLayout from "./layout/FrontLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import "antd/dist/reset.css";
import Cities from "./pages/Cities";
import Otp from "./pages/Otp";
import { msalInstance } from "./msalConfig";
import PermissionDenied from "./pages/PermissionDenied";
import Roles from "./pages/Roles";
import Schedules from "./pages/Schedules";
import Sequences from "./pages/Sequences";
import Devices from "./pages/Device";
import Dashboard from "./pages/Dashboard";
import Logs from "./pages/Logs";
import AppUpdate from "./pages/AppUpdate";

function App() {
  const user = JSON.parse(localStorage.getItem("userData"));
  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          {/* Front Layout Routes */}
          <Route path="/play/:slug" element={<FrontLayout />}>
            <Route index element={<Play />} />
          </Route>
          <Route path="/otp/:slug" element={<FrontLayout />}>
            <Route index element={<Otp />} />
          </Route>
          <Route path="/access-denied" element={<PermissionDenied />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute user={user}>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="roles" element={<Roles />} />
            <Route path="users" element={<Users />} />
            <Route path="cities" element={<Cities />} />
            <Route path="locations" element={<Locations />} />
            <Route path="library" element={<Library />} />
            <Route path="playlists" element={<Playlists />} />
            <Route path="screens" element={<Screens />} />
            <Route path="schedules" element={<Schedules />} />
            <Route path="sequences/:id" element={<Sequences />} />
            <Route path="devices" element={<Devices />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="logs" element={<Logs />} />
            <Route path="app-update" element={<AppUpdate />} />
          </Route>

          <Route path="/error-403" element={<Error403 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Router>
    </MsalProvider>
  );
}

export default App;
